"use client"

import dynamic from "next/dynamic"

const SystemHealthTicker = dynamic(() => import("./SystemHealthTicker"), {
  ssr: false,
})

export default function SystemHealthTickerMount() {
  return <SystemHealthTicker />
}
